import { render, staticRenderFns } from "./contentLearnerCreate.vue?vue&type=template&id=4d934c58&"
import script from "./contentLearnerCreate.vue?vue&type=script&lang=js&"
export * from "./contentLearnerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports